class DeferSection extends HTMLElement {
  connectedCallback() {
    const template = this.querySelector(':scope > template[data-defer-template]');
    if (!template) return;

    const activate = () => {
      this.appendChild(template.content.cloneNode(true));
      template.remove();
      // Let scripts that ran on page load (e.g. the Trustpilot loader) hydrate
      // any widgets that were only just cloned into the DOM.
      this.dispatchEvent(new CustomEvent('defer-section:load', { bubbles: true }));
    };

    // Only activate once the section actually enters the viewport — no preloading.
    // A section can still opt into an earlier trigger via data-defer-root-margin.
    const rootMargin = this.getAttribute('data-defer-root-margin') || '0px';
    const observer = new IntersectionObserver(
      (entries, obs) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            obs.disconnect();
            activate();
            break;
          }
        }
      },
      { rootMargin }
    );
    observer.observe(this);
  }
}

customElements.define('defer-section', DeferSection);
